<template>
  <div>
    <template v-if="hasAddress" :style="!price ? 'color: #11bb2e' : ''">
      <template v-if="isCartLoading">
        <span class="skeleton delivery" />
      </template>
      <template v-else>
        {{ price | price }}
      </template>
    </template>
    <div v-else class="add-address">
      <span>{{ $t('Could not calculate') }}</span>
      <span class="add-address__btn" @click.stop="handleClickAddAddress">
        ( {{ $t('add address') }} )
      </span>
    </div>
  </div>
</template>

<script async>
import { mapGetters } from 'vuex';

export default {
  name: 'OrderDeliveryPrice',
  props: {
    price: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      hasAddress: 'address/getHasAddress',
      isCartLoading: 'cart/isCartLoading'
    })
  },
  methods: {
    handleClickAddAddress () {
      this.$emit('add-address');
    }
  }
}
</script>

<style scoped lang="scss">
.add-address {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 4px;

  &__btn {
    color: #11bb2e;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.skeleton {
  animation: skeleton-loading 1s linear infinite alternate;
  object-fit: cover;
  flex-shrink: 0;
  display: inline-flex;
  border-radius: 4px;
  margin: 0 8px;

  &.delivery {
    width: 92px;
    height: 19px;
  }
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(60, 6%, 94%);
  }
  100% {
    background-color: hsl(0, 0%, 85%);
  }
}
</style>
